module.exports = __webpack_public_path__ + "static/assets/527756fb4ee6a19086a69e0ea8355b5c.mp3";